module.exports = __webpack_public_path__ + "img/CC2001.17434586.png";